import { Button, Col, Row, Container, Table } from 'react-bootstrap';
import toast, { Toaster } from "react-hot-toast";
import { useState, useEffect } from 'react';
import '../css/common.css';
import '../css/hover.css'
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { saveForm, deleteForm } from '../store/Slices/formSlice';
import useValidation from '../helpers/validation';
import * as XLSX from 'xlsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload, faTrash, faDownload } from '@fortawesome/free-solid-svg-icons';

function Finland() {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const userEmail = sessionStorage.getItem('email');

    useEffect(() => {
        const fetchData = async () => {
            if (!userEmail) {
                navigate('/');
                return;
            }
            const form = JSON.parse(localStorage.getItem('form'));

            if (form?.country?.country === 'Finland') {
                fillForm(form);
            }
        };

        fetchData();
    }, [dispatch, navigate]);

    const { validateInput, validationStates, setValidationStates } = useValidation();

    const [operator, setOperator] = useState('');
    const [accNum, setAccNum] = useState('');
    const [telNum, setTelNum] = useState('');

    const [companyName, setCompanyName] = useState('');
    const [contactName, setContactName] = useState('');
    const [city, setCity] = useState('');
    const [vatNum, setVatNum] = useState('');
    const [regNum, setRegNum] = useState('');
    const [clientAddress, setClientAddress] = useState('');
    const [state, setState] = useState('');
    const [zip, setZip] = useState('');
    const [signature, setSignature] = useState('');
    const [date, setDate] = useState('');
    const [printName, setPrintName] = useState('');
    const [phoneNum, setPhoneNum] = useState('');
    //-----------------------------------------------FillForm-------------------------------------------------//

    const fillForm = (form) => {
        const JSONDATA = form;

        setTableDataRange(JSONDATA?.country?.customer?.tableDataRange ?? []);

        setOperator(JSONDATA?.country?.operatorDetails?.Name ?? '');
        setAccNum(JSONDATA?.country?.operatorDetails?.Account_Number ?? '');
        setTelNum(JSONDATA?.country?.operatorDetails?.TelNum ?? '');
        document.querySelector('#operator').value = JSONDATA?.country?.operatorDetails?.Name ?? '';
        document.querySelector('#accNum').value = JSONDATA?.country?.operatorDetails?.Account_Number ?? '';
        document.querySelector('#telNum').value = JSONDATA?.country?.operatorDetails?.TelNum ?? '';

        setCompanyName(JSONDATA?.country?.clientDetails?.Company_Name ?? '');
        setContactName(JSONDATA?.country?.clientDetails?.Contact_Name ?? '');
        setVatNum(JSONDATA?.country?.clientDetails?.VatNum ?? '');
        setRegNum(JSONDATA?.country?.clientDetails?.RegNum ?? '');
        setClientAddress(JSONDATA?.country?.clientDetails?.Address ?? '');
        setCity(JSONDATA?.country?.clientDetails?.City ?? '');
        setState(JSONDATA?.country?.clientDetails?.State ?? '');
        setZip(JSONDATA?.country?.clientDetails?.Zip ?? '');
        setSignature(JSONDATA?.country?.clientDetails?.Signature ?? '');
        setDate(JSONDATA?.country?.clientDetails?.Date ?? '');
        setPrintName(JSONDATA?.country?.clientDetails?.PrintName ?? '');
        setPhoneNum(JSONDATA?.country?.clientDetails?.PhoneNum ?? '');
        document.querySelector('#companyName').value = JSONDATA?.country?.clientDetails?.Company_Name ?? '';
        document.querySelector('#contactName').value = JSONDATA?.country?.clientDetails?.Contact_Name ?? '';
        document.querySelector('#vatNum').value = JSONDATA?.country?.clientDetails?.VatNum ?? '';
        document.querySelector('#regNum').value = JSONDATA?.country?.clientDetails?.RegNum ?? '';
        document.querySelector('#clientAddress').value = JSONDATA?.country?.clientDetails?.Address ?? '';
        document.querySelector('#city').value = JSONDATA?.country?.clientDetails?.City ?? '';
        document.querySelector('#state').value = JSONDATA?.country?.clientDetails?.State ?? '';
        document.querySelector('#zip').value = JSONDATA?.country?.clientDetails?.Zip ?? '';
        document.querySelector('#signature').value = JSONDATA?.country?.clientDetails?.Signature ?? '';
        document.querySelector('#date').value = JSONDATA?.country?.clientDetails?.Date ?? '';
        document.querySelector('#printName').value = JSONDATA?.country?.clientDetails?.PrintName ?? '';
        document.querySelector('#phoneNum').value = JSONDATA?.country?.clientDetails?.PhoneNum ?? '';

    }

    //-----------------------------------------------Hover-------------------------------------------------//

    const [hoveredField, setHoveredField] = useState(null); //hovered field

    const handleMouseEnter = (field) => {
        setHoveredField(field);
    };

    const handleMouseLeave = () => {
        setHoveredField(null);
    };

    //--------------------------------table declaration (DID Range)--------------------------------------//

    const [tableDataRange, setTableDataRange] = useState([{ id: Date.now(), sNumber: '', eNumber: '' }]);

    //adding a row
    const addRow_range = () => {
        setTableDataRange([...tableDataRange, { id: Date.now(), sNumber: '', eNumber: '' }]);
    };

    //removing a row
    const removeRow_range = (id) => {
        setTableDataRange(tableDataRange.filter(row => row.id !== id));
    };

    //change handler of table
    const handleChange_tableRange = (id, key, value) => {
        const updatedData = tableDataRange.map(row => {
            if (row.id === id) {
                return { ...row, [key]: value };
            }
            return row;
        });
        setTableDataRange(updatedData);
    };

    const fileInputRef = React.createRef();  // Create a reference to the file input element
    const [uploadedFileName, setUploadedFileName] = useState('');

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        setUploadedFileName(file.name);

        const reader = new FileReader();
        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];

            // Read headers from row 5 (0-indexed, so index 4)
            const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1, range: 4 });
            if (!jsonData.length) {
                toast.error('Uploaded file is empty or has an invalid format.');
                setUploadedFileName('');
                return;
            }

            const fileHeaders = jsonData[0] || [];
            const expectedHeaders = ['Public from', 'Public to', 'Private from', 'Private to', 'Local Country Value'];

            // Check if headers match
            if (!expectedHeaders.every((header, index) => header === fileHeaders[index])) {
                toast.error('Uploaded file does not match the expected format.');
                setUploadedFileName('');
                return;
            }

            // Read actual data from row 6 onwards
            const dataRows = jsonData.slice(1);

            // Extract relevant data for tableDataRange
            const formattedDataRange = dataRows.map((row, index) => ({
                id: index + 1,
                sNumber: row[0] ? row[0].toString() : '',
                eNumber: row[1] ? row[1].toString() : '',
            }));

            setTableDataRange(formattedDataRange);

            // Validate each row: must be numeric and not empty
            formattedDataRange.forEach(row => {
                const isStartValid = /^[0-9]+$/.test(row.sNumber);
                const isEndValid = /^[0-9]+$/.test(row.eNumber);

                setValidationStates(prev => ({
                    ...prev,
                    [`startNumber-${row.id}`]: isStartValid,
                    [`endNumber-${row.id}`]: isEndValid,
                }));
            });
        };

        reader.readAsArrayBuffer(file);
    };

    const removeUploadedFile = () => {
        setUploadedFileName('');
        fileInputRef.current.value = '';
        setTableDataRange([{ id: Date.now(), sNumber: '', eNumber: '' }]);
    };

    const handleDownload = async () => {
        try {
            // Fetch the file (portabilityImportTemplate.xlsx) from the server
            const response = await fetch(`/portabilityImportTemplate.xlsx?t=${new Date().getTime()}`);

            // Check if the response is valid
            if (!response.ok) throw new Error("Network response was not ok");

            // Convert the response to a Blob
            const blob = await response.blob();

            // Create a URL for the Blob to allow it to be downloaded
            const url = window.URL.createObjectURL(blob);

            // Create an anchor tag dynamically and trigger a click to download the file
            const a = document.createElement("a");
            a.href = url;
            a.download = "portabilityImportTemplate.xlsx"; // File name for download
            document.body.appendChild(a);
            a.click(); // Initiate the download
            document.body.removeChild(a); // Clean up by removing the anchor element
        } catch (error) {
            // Catch any error that occurs during the download process
            console.error("Download failed:", error);
        }
    };

    //-------------------------------------------creating Schema----------------------------------------//

    const json = {
        "country": {
            "country": "Finland",

            "customer": {
                "tableDataRange": tableDataRange
            },

            "operatorDetails": {
                "Name": operator,
                "Account_Number": accNum,
                "TelNum": telNum
            },

            "clientDetails": {
                "Company_Name": companyName,
                "Contact_Name": contactName,
                "VatNum": vatNum,
                "RegNum": regNum,
                "Address": clientAddress,
                "City": city,
                "State": state,
                "Zip": zip,
                "Signature": signature,
                "Date": date,
                "PrintName": printName,
                "PhoneNum": phoneNum
            },
        },
        "email": sessionStorage.getItem('email'),
    };

    const jsonString = JSON.stringify(json);
    console.log(jsonString);

    //-----------------------------------------sending request---------------------------------------------//

    async function Submit(e) {
        let validationErrors = {};

        // Ensure both Start Number and End Number are provided in Range Table
        tableDataRange.forEach(row => {
            const startId = `startNumber-${row.id}`;
            const endId = `endNumber-${row.id}`;

            // Validate start number
            if (!row.sNumber) {
                validationErrors[startId] = 'Please fill in the start of the number range.';
            } else if (!/^[0-9]+$/.test(row.sNumber)) {
                validationErrors[startId] = 'Start number must be numeric.';
            }

            // Validate end number
            if (!row.eNumber) {
                validationErrors[endId] = 'Please fill in the end of the number range.';
            } else if (!/^[0-9]+$/.test(row.eNumber)) {
                validationErrors[endId] = 'End number must be numeric.';
            }
        });

        if (!companyName) {
            validationErrors.companyName = 'Please fill in Company Name';
        }
        if (!contactName) {
            validationErrors.contactName = 'Please fill in Contact Name';
        }
        if (!vatNum) {
            validationErrors.vatNum = 'Please fill in VAT Number';
        }
        if (!signature) {
            validationErrors.signature = 'Please fill in signature';
        }
        if (!date) {
            validationErrors.date = 'Please fill in Date';
        }
        if (!printName) {
            validationErrors.printName = 'Please fill in Authorized Print Name';
        }
        if (!phoneNum) {
            validationErrors.phoneNum = 'Please fill in Phone Number';
        }

        const hasValidationError = Object.values(validationErrors).length > 0;

        if (hasValidationError) {
            // Update validation states
            setValidationStates(prevState => ({
                ...prevState,
                ...Object.keys(validationErrors).reduce((acc, key) => {
                    acc[key] = false;
                    return acc;
                }, {})
            }));

            // Show the first error message and scroll to the field if it exists
            const firstError = Object.values(validationErrors)[0];
            const firstErrorKey = Object.keys(validationErrors)[0];
            const firstErrorElement = document.getElementById(firstErrorKey);

            if (firstErrorElement) {
                firstErrorElement.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            } else {
                console.error(`Element with ID ${firstErrorKey} not found.`);
                toast.error("An error occurred while scrolling to the invalid field.");
            }

            toast.error(firstError);
            return;
        }

        const falseKeys = Object.entries(validationStates)
            .filter(([key, value]) => value === false)
            .map(([key, value]) => key);

        if (falseKeys.length > 0) {
            toast.error(`Please make sure fields in red are correct. \n${falseKeys}`);
            const elem = document.getElementById(falseKeys[0]);
            if (elem) {
                elem.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            } else {
                console.error(`Element with ID ${falseKeys[0]} not found.`);
            }
            return;
        }

        // If all validations pass, proceed with the form submission
        e.preventDefault();
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/generate_loa`, {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                },
                body: jsonString
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const blobData = await response.blob();
            const url = URL.createObjectURL(blobData);
            const a = document.createElement('a');
            a.href = url;
            a.download = accNum + '-LOA.docx';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);

        } catch (error) {
            console.error('Error downloading file: ', error);
            window.location.href = 'https://my-service-space.orange-business.com/wacsmss/group/mssportal/home';
        }
    }

    //----------------------------------------------RESET--------------------------------------------------//

    async function Reset(e) {
        const dataToBeDeleted = { "email": userEmail };
        dispatch(deleteForm(dataToBeDeleted));
        localStorage.removeItem('form');
        window.location.reload();
    }

    // ----------------------------------------------SAVE--------------------------------------------------//

    async function save(e) {
        e.preventDefault();
        const falseKeys = Object.entries(validationStates)
            .filter(([key, value]) => {
                const element = document.getElementById(key);
                return value === false && element && element.value.trim() !== '';
            })
            .map(([key, value]) => key);

        if (falseKeys.length > 0) {
            const elem = document.getElementById(falseKeys[0]);
            elem.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            toast.error(`Please make sure following fields in red are correct before saving `);
            return;
        }

        localStorage.setItem('form', JSON.stringify(json));
        const dataToBeSaved = { "email": userEmail, "json_data": json };
        try {
            const response = await dispatch(saveForm(dataToBeSaved));
            if (response?.payload?.message === "success") {
                toast.success('Form saved successfully');
            }
        } catch (error) {
            toast.error('There was an error processing your request.');
        }
    }

    //-----------------------------------------------JSX----------------------------------------------------//

    return (
        <div>

            <Toaster position="top-center" reverseOrder={false}></Toaster>

            <div className='french'>

                <p><strong>Mandatory fields are marked by *</strong></p>

                <p>As the end user subscriber and owner, I designate Orange Business Services, hereafter, Orange Business Finland Oy, Mikonkatu 9, 00100 Helsinki, Finland , to act as my agent in changing the Responsible Organization & import each of the telephone number(s) specified on this form. </p>

                <Container>

                    <h4 className='text-decoration-underline'>Number Range</h4> <br></br>

                    <Row>
                        <Col>
                            <button
                                variant="secondary"
                                className="inputbox"
                                style={{ alignItems: 'center' }}
                                onClick={() => fileInputRef.current.click()}
                            >
                                <FontAwesomeIcon icon={faUpload} style={{ marginRight: '8px' }} />
                                Upload File
                            </button>
                            <input
                                id="fileUploadInput"
                                type="file"
                                accept=".xlsx, .xls"
                                onChange={handleFileUpload}
                                ref={fileInputRef}
                                style={{ display: 'none' }}
                            />
                        </Col>

                        <Col>
                            <button className="inputbox" onClick={handleDownload} style={{ alignItems: 'center' }}>
                                <FontAwesomeIcon icon={faDownload} style={{ marginRight: '8px' }} />
                                Download number range template
                            </button>
                        </Col>

                        <Col>
                            {uploadedFileName && (
                                <button onClick={removeUploadedFile} className="inputbox" style={{ alignItems: 'center' }}>
                                    <FontAwesomeIcon icon={faTrash} style={{ marginRight: '8px' }} />
                                    Remove
                                </button>
                            )}
                        </Col>

                    </Row>

                    <br />
                    <p>The template is the same used for the btd portability request.</p>
                    <br />

                    <Table striped bordered hover variant="light">
                        <thead>
                            <tr>
                                <th>Number range start*</th>
                                <th>Number range end*</th>
                            </tr>
                        </thead>

                        <tbody>

                            {tableDataRange.map(row => (
                                <tr key={row.id}>

                                    {/* Start Range */}
                                    <td
                                        onMouseEnter={() => handleMouseEnter(`startNumber-${row.id}`)}
                                        onMouseLeave={handleMouseLeave}
                                    >
                                        <input
                                            type="text"
                                            id={`startNumber-${row.id}`}
                                            value={row.sNumber}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                handleChange_tableRange(row.id, 'sNumber', value);

                                                const isValid = /^[0-9]+$/.test(value);
                                                setValidationStates(prev => ({
                                                    ...prev,
                                                    [`startNumber-${row.id}`]: isValid,
                                                }));
                                            }}
                                            className={`inputbox ${validationStates[`startNumber-${row.id}`] === false ? 'error' : ''}`}
                                            onBlur={() => {
                                                const isValid = /^[0-9]+$/.test(row.sNumber);
                                                if (!isValid) {
                                                    toast.error('Only numeric input allowed and cannot be empty.');
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`startNumber-${row.id}`]: false,
                                                    }));
                                                }
                                            }}
                                        />
                                        {hoveredField === `startNumber-${row.id}` && (
                                            <div className="hover-description">
                                                Enter the start number in a range
                                            </div>
                                        )}
                                        {validationStates[`startNumber-${row.id}`] === false && (
                                            <div className="error-message">
                                                Only numeric input allowed and cannot be empty.
                                            </div>
                                        )}
                                    </td>

                                    {/* End Number */}
                                    <td
                                        onMouseEnter={() => handleMouseEnter(`endNumber-${row.id}`)}
                                        onMouseLeave={handleMouseLeave}
                                    >
                                        <input
                                            type="text"
                                            id={`endNumber-${row.id}`}
                                            value={row.eNumber}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                handleChange_tableRange(row.id, 'eNumber', value);

                                                const isValid = /^[0-9]+$/.test(value); // Exactly 11 digits
                                                setValidationStates(prev => ({
                                                    ...prev,
                                                    [`endNumber-${row.id}`]: isValid,
                                                }));
                                            }}
                                            className={`inputbox ${validationStates[`endNumber-${row.id}`] === false ? 'error' : ''}`}
                                            onBlur={() => {
                                                const isValid = /^[0-9]+$/.test(row.eNumber);
                                                if (!isValid) {
                                                    toast.error('Only numeric input allowed and cannot be empty.');
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`endNumber-${row.id}`]: false,
                                                    }));
                                                }
                                            }}
                                        />
                                        {hoveredField === `endNumber-${row.id}` && (
                                            <div className="hover-description">
                                                Enter the end number in a range
                                            </div>
                                        )}
                                        {validationStates[`endNumber-${row.id}`] === false && (
                                            <div className="error-message">
                                                Only numeric input allowed and cannot be empty.
                                            </div>
                                        )}
                                    </td>

                                    <td>
                                        {tableDataRange.length > 1 && (
                                            <button onClick={() => removeRow_range(row.id)}>Remove</button>
                                        )}
                                    </td>
                                </tr>
                            ))}

                        </tbody>
                    </Table>
                    <button onClick={addRow_range}>Add Row</button>

                    <br></br><br></br>

                </Container>

                <br></br><br></br>

                <Container>
                    <p><strong>Tip: If you are doing a full-port, you need to include the Leading Telephone Number. If you are doing a partial-port, leave the Leading Telephone Number out of this list.</strong></p> <br></br>

                    <h2 className='heading'>Identification of the current AND losing Operator (DONOR)</h2> <br></br>

                    <Row>
                        <Col
                            onMouseEnter={() => handleMouseEnter('operator')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Operator Name</label> <br />
                            <input
                                onChange={(e) => setOperator(e.target.value)}
                                type="text"
                                id='operator'
                                placeholder=""
                                className={`inputbox`}
                            />

                            {hoveredField === 'operator' && (
                                <div className="hover-description">
                                    Enter the operator name
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('accNum')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Account Number / Reference (as see on current bill)</label>
                            <input
                                onChange={(e) => setAccNum(e.target.value)}
                                type="text"
                                id="accNum"
                                placeholder=""
                                className={`inputbox ${validationStates.accNum === false ? 'error' : ''}`}
                                onBlur={(e) => {
                                    const value = e.target.value.trim();
                                    const isValid = value === '' || /^[0-9]+$/u.test(value);
                                    setValidationStates(prev => ({ ...prev, accNum: isValid }));

                                    if (value !== '' && !isValid) {
                                        toast.error(
                                            'Only numeric values are allowed.'
                                        );
                                    }
                                }}
                            />

                            {hoveredField === 'accNum' && (
                                <div className="hover-description">
                                    Enter account number of last bill(numeric only)
                                </div>
                            )}
                        </Col>
                    </Row>

                    <br></br>

                    <Row>
                        <Col
                            onMouseEnter={() => handleMouseEnter('telNum')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Leading Telephone Number</label>
                            <input
                                onChange={(e) => setTelNum(e.target.value)}
                                type="text"
                                id="telNum"
                                placeholder=""
                                className={`inputbox ${validationStates.telNum === false ? 'error' : ''}`}
                                onBlur={(e) => {
                                    const value = e.target.value.trim();
                                    const isValid = value === '' || /^[0-9]+$/u.test(value);
                                    setValidationStates(prev => ({ ...prev, telNum: isValid }));

                                    if (value !== '' && !isValid) {
                                        toast.error(
                                            'Only numeric values are allowed.'
                                        );
                                    }
                                }}
                            />

                            {hoveredField === 'telNum' && (
                                <div className="hover-description">
                                    Enter leading telephone number (numeric only)
                                </div>
                            )}
                        </Col>
                    </Row>

                </Container>

                <br></br><br></br>

                <p>I release any third party from liability for acting in accordance with these instructions.

                    I acknowledge to be fully liable for the accuracy of the information herein contained and undertake to pay any and all charges incurred by this porting request.</p> <br></br>

                <Container>

                    <Row>
                        <Col
                            onMouseEnter={() => handleMouseEnter('companyName')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Company Name*</label> <br />
                            <input
                                onChange={(e) => setCompanyName(e.target.value)}
                                type="text"
                                id='companyName'
                                placeholder=""
                                className={`inputbox ${validationStates.companyName === false ? 'error' : ''}`}
                                onBlur={() => validateInput('companyName', /[a-zA-Z0-9]/)}
                            />

                            {hoveredField === 'companyName' && (
                                <div className="hover-description">
                                    Enter company name
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('contactName')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Contact Name*</label> <br />
                            <input
                                onChange={(e) => setContactName(e.target.value)}
                                type="text"
                                id='contactName'
                                placeholder=""
                                className={`inputbox ${validationStates.contactName === false ? 'error' : ''}`}
                                onBlur={() => validateInput('contactName', /[a-zA-Z0-9]/)}
                            />

                            {hoveredField === 'contactName' && (
                                <div className="hover-description">
                                    Enter contact person name
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('vatNum')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>VAT Number*</label> <br />
                            <input
                                onChange={(e) => setVatNum(e.target.value)}
                                type="text"
                                id='vatNum'
                                placeholder=""
                                className={`inputbox ${validationStates.vatNum === false ? 'error' : ''}`}
                                onBlur={() => validateInput('vatNum', /[a-zA-Z0-9]/)}
                            />

                            {hoveredField === 'vatNum' && (
                                <div className="hover-description">
                                    Enter VAT number
                                </div>
                            )}
                        </Col>
                    </Row>

                    <br></br>

                    <Row>
                        <Col
                            onMouseEnter={() => handleMouseEnter('regNum')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Business National Registration Number</label> <br />
                            <input
                                onChange={(e) => setRegNum(e.target.value)}
                                type="text"
                                id="regNum"
                                placeholder=""
                                className={`inputbox ${validationStates.regNum === false ? 'error' : ''}`}
                                onBlur={(e) => {
                                    const value = e.target.value.trim();
                                    const isValid = value === '' || /^[0-9]+$/u.test(value);
                                    setValidationStates(prev => ({ ...prev, regNum: isValid }));

                                    if (value !== '' && !isValid) {
                                        toast.error(
                                            'Only numeric values are allowed.'
                                        );
                                    }
                                }}
                            />

                            {hoveredField === 'regNum' && (
                                <div className="hover-description">
                                    Enter business registration number (numeric only)
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('clientAddress')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Address</label> <br />
                            <input
                                onChange={(e) => setClientAddress(e.target.value)}
                                type="text"
                                id='clientAddress'
                                placeholder=""
                                className={`inputbox`}
                            />

                            {hoveredField === 'clientAddress' && (
                                <div className="hover-description">
                                    Enter Street Name
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('city')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>City</label> <br />
                            <input
                                onChange={(e) => setCity(e.target.value)}
                                type="text"
                                id='city'
                                placeholder=""
                                className={`inputbox`}
                            />

                            {hoveredField === 'city' && (
                                <div className="hover-description">
                                    Enter city name
                                </div>
                            )}
                        </Col>
                    </Row>

                    <br></br>

                    <Row>
                        <Col
                            onMouseEnter={() => handleMouseEnter('state')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>State</label> <br />
                            <input
                                onChange={(e) => setState(e.target.value)}
                                type="text"
                                id='state'
                                placeholder=""
                                className={`inputbox`}
                            />

                            {hoveredField === 'state' && (
                                <div className="hover-description">
                                    Enter state name
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('zip')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Zip</label> <br />
                            <input
                                onChange={(e) => setZip(e.target.value)}
                                type="text"
                                id="zip"
                                placeholder=""
                                className={`inputbox ${validationStates.zip === false ? 'error' : ''}`}
                                onBlur={(e) => {
                                    const value = e.target.value.trim();
                                    const isValid = value === '' || /^[0-9]+$/u.test(value);
                                    setValidationStates(prev => ({ ...prev, zip: isValid }));

                                    if (value !== '' && !isValid) {
                                        toast.error(
                                            'Only numeric values are allowed.'
                                        );
                                    }
                                }}
                            />

                            {hoveredField === 'zip' && (
                                <div className="hover-description">
                                    Enter ZIP code (numeric only)
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('signature')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Signature*</label> <br />
                            <input
                                onChange={(e) => setSignature(e.target.value)}
                                type="text"
                                id='signature'
                                placeholder=""
                                className={`inputbox ${validationStates.signature === false ? 'error' : ''}`}
                                onBlur={() => validateInput('signature', /[a-zA-Z0-9]/)}
                            />

                            {hoveredField === 'signature' && (
                                <div className="hover-description">
                                    Enter authorized signature name
                                </div>
                            )}
                        </Col>
                    </Row>

                    <br></br>

                    <Row>
                        <Col
                            onMouseEnter={() => handleMouseEnter('date')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Date*</label> <br />
                            <input
                                type="date"
                                id="date"
                                value={date}
                                onChange={(e) => setDate(e.target.value)}
                                min={new Date().toISOString().slice(0, 16)} // Disable past dates
                                className={`inputbox ${validationStates.date === false ? 'error' : ''}`}
                                onBlur={() => validateInput('date', /^.*$/)}
                            />
                            {hoveredField === 'date' && (
                                <div className="hover-description">
                                    Date of signing contract
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('printName')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Authorized Print Name*</label> <br />
                            <input
                                onChange={(e) => setPrintName(e.target.value)}
                                type="text"
                                id='printName'
                                placeholder=""
                                className={`inputbox ${validationStates.printName === false ? 'error' : ''}`}
                                onBlur={() => validateInput('printName', /[a-zA-Z0-9]/)}
                            />

                            {hoveredField === 'printName' && (
                                <div className="hover-description">
                                    Enter authorized person signature
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('phoneNum')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Phone Number*</label> <br />
                            <input
                                onChange={(e) => setPhoneNum(e.target.value)}
                                type="text"
                                id="phoneNum"
                                placeholder=""
                                className={`inputbox ${validationStates.phoneNum === false ? 'error' : ''}`}
                                onBlur={(e) => {
                                    const value = e.target.value.trim();
                                    const isValid = value === '' || /^[0-9]+$/u.test(value);
                                    setValidationStates(prev => ({ ...prev, phoneNum: isValid }));

                                    if (value !== '' && !isValid) {
                                        toast.error(
                                            'Only numeric values are allowed.'
                                        );
                                    }
                                }}
                            />

                            {hoveredField === 'phoneNum' && (
                                <div className="hover-description">
                                    Enter phone number (numeric only)
                                </div>
                            )}
                        </Col>
                    </Row>

                </Container>

                <br></br><br></br>

                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Button variant="primary" type="save" onClick={save}>Save</Button>
                    <Button variant="primary" type="submit" onClick={Submit}>Generate LOA</Button>
                    {/* <Button variant="primary" type="autofill" onClick={autofill}>Autofill</Button> */}
                    <Button variant="primary" type="reset" onClick={Reset} style={{ marginRight: '20px' }}>Reset</Button>
                </div>
            </div>

        </div>
    );
}

export default Finland;